// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"297":"bfd063ace7ac45a08ea8","491":"bbaf52da328136ee3de1","945":"016313d8d4a420eaffd9","959":"8df7f7773d3c0d89149d"}[chunkId] + ".chunk.js";
};